/* Testimonials.

   These quotes carried invented company names (Meridian, NovaCart, HELIXPAY),
   and the wordmarks rendered as blank squares once the fake-logo CSS was
   removed. The company names are gone rather than swapped for the real
   customers: putting BrandGrid or CORD4 here would attribute words to a real
   business that it never said, which is a worse problem than an invented brand.

   Sector and headcount stay — they're what make a quote credible — and the
   attribution is honest about being anonymised. Replace with named quotes once
   there's a real one on file with permission. */

const QUOTES = [
  {
    text: 'TeamGrid told us a burnout story our standups never did. We caught it three weeks early.',
    who: 'Ananya Sharma',
    role: 'COO · Fintech, 140 people',
    initials: 'AS',
    grad: 'linear-gradient(135deg,#F2673A,#e0512a)',
  },
  {
    text: 'We swapped three tracking tools and a CRM for one brain. Finance noticed before HR did.',
    who: 'Rahul Mehta',
    role: 'Founder · D2C, 60 people',
    initials: 'RM',
    grad: 'linear-gradient(135deg,#469FD8,#366EB6)',
  },
  {
    text: 'The Monday Founder’s Report is the first thing I read. It replaced four status meetings.',
    who: 'Priya Nair',
    role: 'CEO · SaaS, 220 people',
    initials: 'PN',
    grad: 'linear-gradient(135deg,#6C59A6,#8B75D7)',
  },
];

export default function Quotes() {
  return (
    <section className="sect" id="s-quotes" style={{ paddingTop: '40px' }}>
      <div className="container">
        <h2 className="sect-h2">Loved by fast-moving teams<br /><span className="dim">across 500+ companies</span></h2>

        <div className="quotes">
          {QUOTES.map((q) => (
            <div className="quote" key={q.who}>
              <p>&ldquo;{q.text}&rdquo;</p>
              <div className="qwho">
                <span className="qav" style={{ background: q.grad }}>{q.initials}</span>
                <div>
                  <div className="qn">{q.who}</div>
                  <div className="qr">{q.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="rated">
          <span className="stars">★★★★★</span><br />
          RATED 4.8/5 BY TEAMS THAT SWITCHED FROM SURVEILLANCE TOOLS
        </p>
      </div>
    </section>
  );
}
